import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import cx from 'classnames';
import React from 'react';

type PopoverProps = {
  children: React.ReactNode;
  menuItem: React.ReactNode;
  handleOpen?: (isOpen: boolean) => void;
  className?: string;
};

// Inner component that can use hooks
const DropdownInner = React.forwardRef<
  HTMLButtonElement,
  PopoverProps & { open: boolean }
>(({ menuItem, children, handleOpen, className, open }, ref) => {
  // Use useEffect to track open state changes
  React.useEffect(() => {
    handleOpen?.(open);
  }, [open, handleOpen]);

  return (
    <>
      <PopoverButton
        ref={ref}
        className={cx(
          'flex items-center gap-1 rounded-md px-3 py-2 text-base font-semibold text-heading',
          'outline-none focus-visible:ring-2 focus-visible:ring-blue',
          'group',
        )}
      >
        {menuItem}
      </PopoverButton>

      <PopoverPanel
        anchor="bottom"
        transition
        modal
        className={cx(
          'z-50 w-screen rounded-b-xl bg-surface/90 py-12 text-base shadow-xl backdrop-blur-md transition-all duration-200 ease-in-out data-closed:-translate-y-10 data-closed:opacity-0',
          className,
        )}
      >
        {children}
      </PopoverPanel>
    </>
  );
});

DropdownInner.displayName = 'DropdownInner';

// Main DropdownItem component
const DropdownItem = React.forwardRef<HTMLButtonElement, PopoverProps>(
  ({ menuItem, children, handleOpen, className }, ref) => {
    return (
      <Popover>
        {({ open }) => (
          <DropdownInner
            ref={ref}
            open={open}
            menuItem={menuItem}
            handleOpen={handleOpen}
            className={className}
          >
            {children}
          </DropdownInner>
        )}
      </Popover>
    );
  },
);

DropdownItem.displayName = 'DropdownItem';
export default DropdownItem;
